let cache = {};

const USERS_KEY = 'get./api/1/admin/users';

// partial matching
const urlsAffectingSeaService = [
    'put./api/1/user/cg719s',
    'post./api/1/user/cod',
    'post./api/1/user/ssl',
    'post./api/1/user/cg719s',
    'post./api/1/user/uscg_aops',
    'post./api/1/user/tankerman',
    'delete./api/1/user/cod',
    'delete./api/1/user/ssl',
    'delete./api/1/user/cg719s',
    'delete./api/1/user/uscg_aops',
    'delete./api/1/user/tankerman',
];

// exact
const seaServiceUrls = [
    'get./api/1/user/all_forms/summary',
    'get./api/1/user/all_documents/summary',
    'get./api/1/user/seaservices/summary',
];

// partial matching
const urlsAffectingDocuments = [
    ...urlsAffectingSeaService,
    'post./api/1/user/cpr',
    'post./api/1/user/nvic',
    'post./api/1/user/courses',
    'post./api/1/user/supporting_document',
    'delete./api/1/user/cpr',
    'delete./api/1/user/nvic',
    'delete./api/1/user/courses',
    'delete./api/1/user/supporting_document',
];

// partial matching
const urlsAffectingExpiration = [
    'post./api/1/user/cpr',
    'post./api/1/user/nvic',
    'post./api/1/user/courses',
    'post./api/1/user/supporting_document',
    'delete./api/1/user/cpr',
    'delete./api/1/user/nvic',
    'delete./api/1/user/courses',
    'delete./api/1/user/supporting_document',
    '/api/1/user/get_mmld_all?lastname',
];

// exact
const documentUrls = [
    'get./api/1/user/all_documents/summary',
    'get./api/1/user/application_checklist',
];

const adminSessionCache = [USERS_KEY];

const getSignature = config => {
    return `${config.method}.${config.url}${
        config.params ? '.' + JSON.stringify(config.params) : ''
    }`;
};

const actionTypes = ['put', 'post', 'delete'];

// Hydrate from sessionStorage on init
adminSessionCache.forEach(signature => {
    const data = window.sessionStorage.getItem(signature);
    if (data) {
        cache = {
            ...cache,
            [signature]: JSON.parse(data),
        };
    }
});

const reducer = (state, action) => {
    switch (action.type) {
        case 'TRIGGER_PRUNING':
            const signature = getSignature(action);
            // build up a set of all possible endpoints to delete
            let clearSet = new Set();
            if (
                urlsAffectingSeaService.some(
                    url => signature.search(url) !== -1
                )
            ) {
                seaServiceUrls.forEach(url => clearSet.add(url));
            }
            if (
                urlsAffectingDocuments.some(url => signature.search(url) !== -1)
            ) {
                documentUrls.forEach(url => clearSet.add(url));
            }
            if (
                urlsAffectingExpiration.some(
                    url => url.search(signature) !== -1
                )
            ) {
                clearSet.add('get./api/1/user/expiration_dates');
            }
            // if looking for new MMLD info, forget MMLD passive
            if (
                signature.search('/api/1/user/get_mmld_all') !== -1 &&
                action.params !== null
            ) {
                clearSet.add('get./api/1/user/get_mmld_all');
            }
            // vessels new updates user_vessels
            if (signature.search('/api/1/vessels/new') !== -1) {
                clearSet.add('get./api/1/vessels/');
            }
            // put, post, and delete all remove remembered get
            if (actionTypes.includes(action.method)) {
                clearSet.add(`get.${action.url}`);
            }
            // build up the output.
            // Only add back in keys which do not match any of the clear list
            let output = {};
            const clearList = Array.from(clearSet);
            Object.keys(state).forEach(key => {
                if (!clearList.some(url => key.search(url) !== -1)) {
                    output[key] = state[key];
                }
            });
            return output;
        case 'UPDATE':
            if (adminSessionCache.some(sig => sig.search(action.key) !== -1)) {
                window.sessionStorage.setItem(
                    action.key,
                    JSON.stringify(action.value)
                );
            }
            return {...state, [action.key]: action.value};
        case 'REMOVE':
            if (adminSessionCache.some(sig => sig.search(action.key) !== -1)) {
                window.sessionStorage.removeItem(action.key);
            }
            const {[action.key]: _, ...rest} = state;
            return rest;
        case 'CLEAR_ALL':
            adminSessionCache.forEach(sig => {
                window.sessionStorage.removeItem(sig);
            });
            return {};
        default:
            return state;
    }
};

const dispatch = ({type, method, url, params, key, value}) => {
    cache = reducer(cache, {
        type,
        method,
        url,
        params,
        key,
        value,
    });
};

const Cache = {
    endpointStore: () => cache,
    pruneEndpoints: (method, url, params = null) => {
        dispatch({
            type: 'TRIGGER_PRUNING',
            method: method,
            url: url,
            params: params,
        });
    },
    updateStore: (key, value) => {
        dispatch({type: 'UPDATE', key: key, value: value});
    },
    removeElement: key => {
        dispatch({type: 'REMOVE', key: key});
    },
    clearStore: () => {
        dispatch({type: 'CLEAR_ALL'});
    },
};

export default Cache;
export {getSignature, USERS_KEY};
